import React from 'react';
import { Outlet, Link } from 'react-router-dom';

const AuthLayout = () => {
  return (
    <div className="auth-layout">
      <div className="auth-header">
        {/* <Link to="/" className="auth-logo">
          Your App Name
        </Link> */}
      </div>
      <div className="auth-container">
        <Outlet />
      </div>
      
    </div>
  );
};

export default AuthLayout;